import * as React from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { IconWrapper } from "common/icons";
import PACKS from "common/icons/packs";
import OverlayTooltip from "common/components/overlayTooltip";
import { Shares } from "common/components/overlayTooltip/preset";
import { useIntl } from "common/intl/helpers";

const styles = require("./externalShare.scss");

interface IProps {
  shareUrl: string;
}

const ExternalShareTextIconButton: React.FC<IProps> = ({ shareUrl }) => {
  const intl = useIntl();
  const [open, setOpenState] = React.useState(false);
  const handleToggleOpen = React.useCallback(() => {
    setOpenState(!open);
  }, [open]);
  const handleClose = React.useCallback(() => {
    setOpenState(false);
  }, []);
  const changeableIcon = PACKS.ENGAGE.CARD_DECK_SHARE_NORMAL;
  const title = intl.formatMessage({ id: "share" });

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div className={styles.container} title={title}>
        <OverlayTooltip
          position="top-end"
          tooltipContent={<Shares shareUrl={shareUrl} />}
          open={open}
          onClose={handleClose}
          disableFocusListener={true}
          disableHoverListener={true}
          disableTouchListener={true}
        >
          <button className={styles.textIconButton} onClick={handleToggleOpen}>
            <span className={styles.iconWrapper}>
              <IconWrapper
                tagName="span"
                icon={changeableIcon}
                className={styles.icon}
              />
            </span>
          </button>
        </OverlayTooltip>
      </div>
    </ClickAwayListener>
  );
};

export default ExternalShareTextIconButton;
